module.exports = __webpack_public_path__ + "static/img/s16.62c888ba.png";